import React, { useState,useEffect } from 'react';
import Sidebar from '../../components/sidebar';
import Container from 'react-bootstrap/Container';

const  ViewProfile = () =>{
    const [formData, setFormData] = useState({});
    const [userType, setUserType] = useState("");
  

useEffect(()=>{

    console.log("useeffect")
    let usertype = JSON.parse(localStorage.getItem('roleType'));
 
    setUserType(usertype);
    const  userdetails = JSON.parse(localStorage.getItem('userdetails'));
    console.log('userdetials', typeof userdetails,userdetails)
    setFormData(userdetails);

},[])

    return (
        <div>
        
        <Sidebar />
           
        <div className="add-user view-profile">
        <Container>
            <h1>View Profile</h1>
           
                <div className="general-information">
                    <h6>General Information</h6>
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label for="first_name">
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    id="first_name"
                                    name="first_name"
                                    value={formData.first_name}
                                    placeholder="Enter your first name"
                                    required
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label for="middle_name">Middle Name</label>
                                <input
                                    type="text"
                                    id="middle_name"
                                    name="middle_name"
                                    value={formData.middle_name}
                                    placeholder="Enter your Middle name"
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label for="last_name">
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    value={formData.last_name}
                                    placeholder="Enter your Last name"
                                    required
                                    readOnly
                                   
                                />
                            </div>
                        </div>
                       
                    </div>
                    <div className="row">
                       
                       <div className="col-sm-4">
                           <div className="form-group">
                               <label for="email">
                                   E-mail
                               </label>
                               <input
                                   type="text"
                                   id="email"
                                   name="email"
                                   value={formData.email_address}
                                   placeholder="Enter your E-mail Address"
                                   readOnly
                                   required
                               />
                           </div>
                       </div>
                       <div className="col-sm-4">
                           <div className="form-group">
                               <label for="phone_number">
                                   Phone Number
                               </label>
                               <input
                                   type="text"
                                   id="phone_number"
                                   name="phone_number"
                                   placeholder="Enter your Phone Number"
                                   value={formData.phone_number}
                                   required
                                   readOnly
                               />
                           </div>
                       </div>
                   </div>
                </div>
               
              
                <div className="account-maintenance">
                    <h6>Account Maintenance</h6>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label for="status">Status</label>
                                <input
                                    type="text"
                                    id="status"
                                    name="status"
                                    placeholder="Enter your status"
                                    value={formData.status}
                                    required
                                    readOnly
                                />
                            </div>
                        </div>
                       
                    </div>
                </div>
            

        </Container>
        </div>
           
         
        </div>
      );
}

export default ViewProfile